import React from "react";
import JitsiRoom from "../components/JitsiRoom";
import { Video } from "lucide-react";

export default function Meet() {
  return (
    <div className="space-y-6">
      <div>
        <h1 className="font-display text-3xl font-700 tracking-tight text-slate-100 flex items-center gap-2">
          <Video className="h-7 w-7 text-teal" /> Team Room
        </h1>
        <p className="text-sm text-slate-400 mt-1">Jump on a call with the team — audio, video and screen sharing for live clarifications.</p>
      </div>
      <JitsiRoom room="TitleHubOps-TeamRoom-8f3a1c" height="calc(100vh - 230px)" />
    </div>
  );
}
